import {
  ArrowLeftOnRectangleIcon,
  ArrowPathIcon,
  ArrowUturnLeftIcon,
  InboxArrowDownIcon,
  PencilSquareIcon,
} from "@heroicons/react/20/solid";
import { CloudArrowUpIcon } from '@heroicons/react/24/solid';
import {
  BallotMarkupFunctionState,
  BallotMarkupModelsState,
} from "../hooks/use-ballot-markup";

type SideMenuProps = {
  functions: BallotMarkupFunctionState;
  models: BallotMarkupModelsState;
  reUploadPdf: () => void;
};

const SideMenu = ({ functions, models, reUploadPdf }: SideMenuProps) => {
  const generateDisabled =
    models.currentMarks.length !== models.totalMarksNeeded ||
    models.loading ||
    models.saving ||
    models.generating;

  const disabled = models.loading || models.saving || models.generating;

  return (
    <div className="sticky flex flex-col text-center bg-white border shadow-md top-10 w-36 mr-7 h-fit border-primary-blue border-l-transparent rounded-r-md shadow-gray-400">
      <button
        className={`inline-block align-middle border border-primary-blue text-primary-blue font-semibold text-xs uppercase tracking-wide h-16 w-28 m-3 rounded hover:bg-blue-100 hover:cursor-pointer`}
        onClick={reUploadPdf}
      >
        <CloudArrowUpIcon
          className={`text-primary-blue h-10 w-10 p-2 m-auto rounded-l-md`}
          aria-hidden="true"
        />
        Reupload PDF
      </button>
      <button
        className={`inline-block align-middle border border-primary-blue text-primary-blue font-semibold text-xs uppercase tracking-wide h-16 w-28 m-3 rounded hover:bg-blue-100 hover:cursor-pointer ${disabled || models.currentMarks.length === 0
            ? "opacity-50 cursor-not-allowed"
            : ""
          }`}
        onClick={() => functions.undoMark()}
        disabled={disabled || models.currentMarks.length === 0}
      >
        <ArrowUturnLeftIcon
          className={`text-primary-blue h-10 w-10 p-2 m-auto rounded-l-md`}
          aria-hidden="true"
        />
        Undo
      </button>
      <button
        className={`inline-block align-middle border border-primary-blue text-primary-blue font-semibold text-xs uppercase tracking-wide h-16 w-28 m-3 rounded hover:bg-blue-100 hover:cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        onClick={() => functions.openChartSearch()}
        disabled={disabled}
      >
        <ArrowLeftOnRectangleIcon
          className={`text-primary-blue h-10 w-10 p-2 m-auto rounded-l-md`}
          aria-hidden="true"
        />
        Import Marks
      </button>
      <button
        className={`inline-block align-middle border border-primary-blue text-primary-blue font-semibold text-xs uppercase tracking-wide h-16 w-28 m-3 rounded hover:bg-blue-100 hover:cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        onClick={() => functions.saveMarks()}
        disabled={disabled}
      >
        <InboxArrowDownIcon
          className={`text-primary-blue h-10 w-10 p-2 m-auto rounded-l-md`}
          aria-hidden="true"
        />
        Save
      </button>
      <button
        className={`inline-block align-middle border border-primary-blue text-primary-blue font-semibold text-xs uppercase tracking-wide h-16 w-28 m-3 rounded hover:bg-blue-100 hover:cursor-pointer ${disabled || models.currentMarks.length === 0
            ? "opacity-50 cursor-not-allowed"
            : ""
          }`}
        onClick={() => functions.startClearMarks()}
        disabled={disabled || models.currentMarks.length === 0}
      >
        <ArrowPathIcon
          className={`text-primary-blue h-10 w-10 p-2 m-auto rounded-l-md`}
          aria-hidden="true"
        />
        Reset Marks
      </button>
      <button
        className={`inline-block align-middle border border-primary-blue text-primary-blue font-semibold text-xs uppercase tracking-wide h-16 w-28 m-3 rounded hover:bg-blue-100 hover:cursor-pointer ${generateDisabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        onClick={() => {
          functions.generateTestDeck();
        }}
        disabled={generateDisabled}
      >
        <PencilSquareIcon
          className={`text-primary-blue h-10 w-10 p-2 m-auto rounded-l-md`}
          aria-hidden="true"
        />
        Generate PDF
      </button>
      <div className="p-2">
        <img src="/logo-2.png" alt="ballot chart logo" />
      </div>
    </div>
  );
};

export default SideMenu;
